import {UntypedFormGroup} from '@angular/forms';
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'getLevelBiochemical',
  pure: false
})
export class GetLevelBiochemicalPipe implements PipeTransform {

  transform(form: UntypedFormGroup | any): { value: number, inference: string, difference: boolean } {
    return {
      value: form.get('value').value,
      difference: form.get('value').value < form.get('reference').get('min').value || form.get('value').value > form.get('reference').get('max').value,
      inference: form.get('value').value < form.get('reference').get('min').value ? 'Bajo nivel' :
        form.get('value').value > form.get('reference').get('max').value ? 'Alto nivel' : ''
    };
  }

}
